// extracted by css-extract-rspack-plugin
export default {"placeholder":"FolderPlaceholderItem_placeholder__j+9mP","text":"FolderPlaceholderItem_text__0QJkL","indicator":"FolderPlaceholderItem_indicator__REVCx"};